import React, { useRef, useState } from 'react';
import { Loader2, PenLine, RotateCcw, XCircle } from 'lucide-react';

const usePad = () => {
  const ref = useRef(null);
  const [drawn, setDrawn] = useState(false);
  const pos = (e) => { const r = ref.current.getBoundingClientRect(); const p = e.touches?.[0] || e; return [p.clientX - r.left, p.clientY - r.top]; };
  const start = (e) => { e.preventDefault(); const c = ref.current.getContext('2d'); c.lineWidth = 2.2; c.lineCap = 'round'; c.strokeStyle = '#111'; c.beginPath(); c.moveTo(...pos(e)); ref.current.dataset.on = '1'; };
  const move = (e) => { if (ref.current.dataset.on !== '1') return; e.preventDefault(); const c = ref.current.getContext('2d'); c.lineTo(...pos(e)); c.stroke(); setDrawn(true); };
  const end = () => { if (ref.current) ref.current.dataset.on = ''; };
  const clear = () => { ref.current.getContext('2d').clearRect(0, 0, ref.current.width, ref.current.height); setDrawn(false); };
  return { ref, drawn, clear, handlers: { onMouseDown: start, onMouseMove: move, onMouseUp: end, onMouseLeave: end, onTouchStart: start, onTouchMove: move, onTouchEnd: end } };
};

export const OasisSignModal = ({ onSign, onClose, signing }) => {
  const pad = usePad();
  const [password, setPassword] = useState('');
  const [credentials, setCredentials] = useState('RN');
  const submit = (e) => { e.preventDefault(); onSign({ signature: pad.ref.current.toDataURL('image/png'), password, credentials }); };
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-testid="oasis-sign-modal">
      <form onSubmit={submit} className="bg-white rounded-lg w-full max-w-lg overflow-hidden">
        <div className="bg-gray-900 text-white px-5 py-3 flex justify-between items-center">
          <h3 className="font-semibold text-[#d4af37] flex items-center gap-2"><PenLine className="w-4 h-4" /> Sign and lock OASIS</h3>
          <button type="button" onClick={onClose} data-testid="oasis-sign-close"><XCircle className="w-5 h-5" /></button>
        </div>
        <div className="p-5 space-y-4">
          <div>
            <div className="flex justify-between items-center mb-1">
              <label className="text-sm font-medium">Draw your signature</label>
              <button type="button" onClick={pad.clear} className="text-xs text-gray-600 flex items-center gap-1" data-testid="oasis-sign-clear"><RotateCcw className="w-3 h-3" /> Clear</button>
            </div>
            <canvas ref={pad.ref} width={440} height={140} {...pad.handlers} className="w-full border-2 border-dashed rounded bg-gray-50 touch-none cursor-crosshair" data-testid="oasis-sign-canvas" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <label className="text-sm">Credentials
              <input value={credentials} onChange={(e) => setCredentials(e.target.value)} className="mt-1 w-full border rounded px-3 py-2" data-testid="oasis-sign-credentials" />
            </label>
            <label className="text-sm">Your password
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 w-full border rounded px-3 py-2" autoComplete="current-password" data-testid="oasis-sign-password" />
            </label>
          </div>
          <p className="text-xs text-gray-500">By signing you attest this assessment is accurate. It will be locked; only the office can unlock it, with a reason.</p>
          <button disabled={!pad.drawn || !password || signing} className="w-full py-2 rounded bg-[#d4af37] text-gray-900 font-semibold disabled:opacity-50 flex items-center justify-center gap-2" data-testid="oasis-sign-submit">
            {signing && <Loader2 className="w-4 h-4 animate-spin" />} Sign and lock
          </button>
        </div>
      </form>
    </div>
  );
};
